/*
 * Game state
 * ==========
 *
 * A sample Game state, displaying the Phaser logo.
 */

import Logo from '../objects/Logo';


import Player from '../objects/Player.js';

var level = 0;

export default class Game extends Phaser.State {

    create() {

        this.game.stage.backgroundColor = '#e5ba69';

        const {centerX: x, centerY: y} = this.world;

        // this.add.existing(new Logo(this.game, x, y));

        this.bkgr = this.add.sprite(0,0, 'background_600');
        this.bkgr.alpha = 0.7;


        this.input.onDown.add(this._onDown, this);


        // this.test = new Test(this.game, this.game.world, 'player1', false, false);

        // set level size
        this.game.world.setBounds(0, 0, 1600, 600);

        this.player1 = new Player(this, 'player1', 10, 495);


        this.physics.arcade.gravity.y = 400;


    // ==================================
    // CONTROLS
    // ==================================
        //  Some basic controls
        this.cursors = this.input.keyboard.createCursorKeys();






    // ==================================
    // LEVEL: TARGET PRACTICE
    // ==================================

        this.potteryCount = 6;
        this.potteryDone = 0;
        this.shotsDone = 0;
        this.startTime = Date.now();

        this.gameRunning = true;

        if (level == 0) {

            var sprite = null;
            this.targets = this.game.add.group(this.game.world, 'targets', false, true, Phaser.Physics.ARCADE);
            for (var i = 0; i < this.potteryCount; i++) {

                // sprite = this.targets.create(300+i*220, 290, 'pottery');
                // sprite.scale.setTo(0.125, 0.125);

                sprite = this.targets.create(300+i*220, 290, 'pottery_small');


            }
            // this.targets.setAll('body.allowGravity', false);



            this.floor = this.add.bitmapData(1607, 285)
            this.floor.draw('floor');
            this.floor.update();
            this.floor.addToWorld(0, 400);
        }


        this.header = this.add.sprite(0,10, 'header');
        this.header.fixedToCamera = true;

        this.style_press = { font: "italic 19px Arial", fill: "#000000", align: "center" };
        this.scoretext = this.add.text(300, 12,
            "Pottery hit: " + this.potteryDone + " of " + this.potteryCount + "\r" +
            "Shots taken: " + this.shotsDone + "", this.style_press);
        this.scoretext.fixedToCamera = true;
        this.scoretext.lineSpacing = -10;

    }


    test() {
        console.log('test');
        this.floor.blendDestinationOut();
        // this._i96.parent.floor.circle(x, y+400, 160, 'rgba(100, 100, 200, 255');
        console.log(this.floor.getPixel(300, 200));

        this.floor.circle(250, 150, 20, 'rgba(0, 200, 0, 255');
        // this.floor.blendReset();
        this.floor.update();

        // this.floor.delete();

        console.log(this.floor.getPixel(300, 200));
    }

    _updateTimer() {
        var t = new Date(1970,0,1);
        t.setSeconds(this.counter);
        this.counter--;
        //console.log(t.toTimeString());
        var s = t.toTimeString().substr(3,5);
        this.timetext.setText(s);

        if (this.counter < 0) {
            this.failed('time');
        }
    }


    _potteryVsLand() {

        this.targets.forEach(function(item){

            if (item.body.allowGravity) {

                var x = Math.floor(item.x);
                var y = Math.floor(item.y);
                // console.log(x,y-400);
                var rgba = this.floor.getPixel(x, y-350);
                // console.log(rgba);
                if (rgba.a > 0) {
                    item.body.allowGravity = false;
                    item.body.velocity.x = 0;
                    item.body.velocity.y = 0;
                }
            }
        }, this);


    }



    _backToMenu() {
        this.state.start('Menu');
    }





    _onKey() {
        if (event.keyCode === Phaser.Keyboard.ESC) {
            this._backToMenu();
        }
    }

    _onDown() {
        // this.state.start('Game');
        console.log('mouse button');
    }


    _showScore() {
        this.scoretext.setText(
            "Pottery hit: " + this.potteryDone + " of " + this.potteryCount + "\r" +
            "Shots taken: " + this.shotsDone + "");

    }

    _updateScore() {
        this.potteryDone++;
        console.log(this.potteryDone);
        this._showScore();
        if (this.potteryDone == this.potteryCount) {
            this._finishGame();
        }
    }


    _finishGame() {

        this.camera.follow();
        this.camera.x = 0;
        this.camera.y = 0;

        this.player1._killBullet();

        if (this.player1.tween !== null && typeof this.player1.tween !== "undefined") {
            this.player1.tween.stop();
        } else {
            // console.log('no tween');
        }

        this.gameRunning = false;
        this.bkgr = this.add.sprite(0,0, 'titlescreen');
        this.info = this.add.text(150, 230,
            'The pottery has been destroyed, you look down at the mess\r'
            +'you created and wonder what made you do what you did. \r'
            +'\r'
            +'You missed ' + (this.shotsDone - this.potteryCount) + ' in ' + Math.round( (Date.now() - this.startTime) / 1000) + " seconds.\r"
            +'Written for LD#36 by Larzan, the unmotivated one.\r'
            +'Press ESC to get back to the title screen...\r'
            +'Or not...\r'
            +'\r'
            +'Anyways, have a nice rest of your life, Enjoy :)',
            this.style_press);
    }



    update() {

        if (this.gameRunning) {

            this.player1._update();

            this._potteryVsLand();

        }

    }

}
